import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import './WalletCards.css';

const CARD_HEIGHT = 220;
const STACK_OFFSET = 52;
const MOCK_DELAY_MS = 420;

const MOCK_CARDS = [
  { id: 'c-1024', color: '#0f4c81', bankName: 'Skyline Bank' },
  { id: 'c-2048', color: '#1f7a5a', bankName: 'Harborline' },
  { id: 'c-4096', color: '#b45309', bankName: 'Summit Union' },
  { id: 'c-8192', color: '#111827', bankName: 'Atlas Reserve' },
  { id: 'c-1638', color: '#7c2d12', bankName: 'Northwind' },
];

const fetchMockCards = () =>
  axios.get('/api/mock-wallet-cards', {
    adapter: (config) =>
      new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            data: MOCK_CARDS,
            status: 200,
            statusText: 'OK',
            headers: {},
            config,
          });
        }, MOCK_DELAY_MS);
      }),
  });

export default function WalletCards() {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');


  useEffect(() => {
    let isActive = true;
    setLoading(true);
    setError('');

    fetchMockCards()
      .then((res) => {
        if (!isActive) return;
        setCards(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        if (!isActive) return;
        setError(err?.message || 'Unable to load cards.');
      })
      .finally(() => {
        if (!isActive) return;
        setLoading(false);
      });

    return () => {
      isActive = false;
    };
  }, []);

  const containerHeight = useMemo(() => {
    if (!cards.length) return CARD_HEIGHT + 24;
    return CARD_HEIGHT + (cards.length - 1) * STACK_OFFSET + 24;
  }, [cards.length]);

  return (
    <div className="wallet-page">
      <header className="wallet-header">
        <p className="wallet-kicker">Wallet Cards</p>
        <h1 className="wallet-title">Stacked Wallet</h1>
        <p className="wallet-subtitle">Your cards are stacked in order.</p>
      </header>

      <div
        className="wallet-stack"
        style={{
          '--stack-height': `${containerHeight}px`,
          '--card-height': `${CARD_HEIGHT}px`,
          '--stack-offset': `${STACK_OFFSET}px`,
        }}
      >
        {cards.map((card, index) => {
          const translateY = 0;
          const scale = 1;
          const lastFour = String(1000 + index * 117).slice(-4);

          return (
            <div
              key={card.id}
              className="wallet-card"
              style={{
                top: `${index * STACK_OFFSET}px`,
                zIndex: index + 1,
                transform: `translateY(${translateY}px) scale(${scale})`,
                '--card-color': card.color,
                animationDelay: `${index * 90}ms`,
              }}
            >
              <div className="wallet-card__sheen" aria-hidden="true"></div>
              <div className="wallet-card__content">
                <div className="wallet-card__bank">{card.bankName}</div>
                <div className="wallet-card__number">**** {lastFour}</div>
                <div className="wallet-card__footer">
                  <div className="wallet-card__chip" aria-hidden="true"></div>
                  <div className="wallet-card__label">Primary</div>
                </div>
              </div>
            </div>
          );
        })}

        {loading && <div className="wallet-status">Loading cards...</div>}
        {error && <div className="wallet-status is-error">{error}</div>}
        {!loading && !error && cards.length === 0 && (
          <div className="wallet-status">No cards available.</div>
        )}
      </div>
    </div>
  );
}
